import { SupplyWalkSingleForHubsContainer } from "./container";
import { PageFrame } from "../../components/page_frame";

export const SupplyWalkSingleForHubsPage = () => {
  return (
    <PageFrame>
      <SupplyWalkSingleForHubsContainer />
    </PageFrame>
  );
};
